import React from "react";
import { ReactComponent as GithubIcon } from "../../icons/github-icon.svg";
import { ReactComponent as GotoIcon } from "../../icons/go-to-location.svg";

const ProjectItem = ({ name, desc, img, tech, gitlink, demolink, alt }) => {
  return (
    <div className="w-full border-b border-yellow-100 font-Fira py-4">
      <div className="flex flex-col  md:flex-row">
        <div className="w-60 h-60 mx-auto">
          <img
            src={img}
            alt={alt}
            className="w-60 h-60 object-cover object-top opacity-90"
          />
        </div>
        <div className="flex flex-col flex-1">
          <h1 className="text-2xl lg:text-left  text-center font-bold md:ml-10 text-yellow-50 pointer-events-none">
            {name}
          </h1>
          <div className="md:hidden flex gap-4 mx-auto py-3">
            <a
              href={gitlink}
              target="_blank"
              rel="noreferrer"
              className="hover:scale-110 transition duration-150 transform"
            >
              <GithubIcon className="h-6 w-6" />
            </a>
            <a
              href={demolink}
              target="_blank"
              rel="noreferrer"
              className="hover:scale-110 transition duration-150 transform"
            >
              <GotoIcon className="h-6 w-6" />
            </a>
          </div>
          <p className="md:px-6 md:ml-4 px-20 sm:py-6 italic lg:text-left text-center  text-yellow-50 pointer-events-none">
            {desc}
          </p>
        </div>
        <div className="hidden md:block flex-1 text-center relative py-6">
          <h1 className="text-yellow-100 underline text-lg pointer-events-none">
            Made with:
          </h1>
          <div className="flex justify-center pointer-events-none flex-wrap p-2 italic mb-8">
            {tech.map((i) => {
              return i !== tech[tech.length - 1] ? i + ", " : i;
            })}
          </div>
          <div className="w-full flex flex-col absolute gap-2 justify-center">
            <h1 className="text-md font-bold text-yellow-50 underline pointer-events-none p-2">
              Links:
            </h1>
            <div className="flex justify-center gap-3">
              <a
                href={gitlink}
                target="_blank"
                rel="noreferrer"
                className="hover:scale-110 transition duration-150 transform"
              >
                <GithubIcon className="h-6 w-6" />
              </a>
              <a
                href={demolink}
                target="_blank"
                rel="noreferrer"
                className="hover:scale-110 transition duration-150 transform"
              >
                <GotoIcon className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectItem;
